export const FORM_NAME_LOGIN_FORM = 'LoginForm'
export const FORM_NAME_CHALLENGE_CHOICE = 'ChallengeChoice'
export const FORM_NAME_CHALLENGE_QUESTION = 'ChallengeQuestion'
export const FORM_NAME_CHANGE_PASSWORD = 'ChangePassword'
export const FORM_NAME_ONE_TIME_PASSCODE = 'OneTimePasscode'
export const MFA_ANSWERED = 'MFA_ANSWERED'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const FORM_NAME_USER_ID = 'UserIdForm'

export const PASSWORD_MODE = {
  TEMP_PASSWORD: 'TEMP_PASSWORD',
  FORGOT_PASSWORD_CHANGE: 'FORGOT_PASSWORD_CHANGE',
  CHANGE_PASSWORD_LOGGED_IN: 'CHANGE_PASSWORD_LOGGED_IN',
}
